<div class="sm fade__in">
  <ng-content select="app-sm-icon"></ng-content>
</div>
